import { Box } from "@mui/material";
import { setDimensionadoDrawerStatus } from "src/store/vendas/projetos/actions";
import theme from "src/theme/light";
import { Layout, LayoutProps } from "../../_layouts";
import { PremissasText } from "../../_layouts/containers/Premissa";
import { GradientButton } from "src/framework/components/buttons/GradientButton";

interface LayoutProjetoDimensionadoProps extends LayoutProps {
  mostrarPremissas?: boolean
} 

const LayoutProjetoDimensionado: React.FC<LayoutProjetoDimensionadoProps> = ({children, mostrarPremissas = true, ...props}) => {
  return (
    <>
      <Layout {...props}>
        <>
          {children}

          {mostrarPremissas && (
            <Box p={2}>
              <Box borderRadius="8px" p={2} width='100%' height={"auto"} bgcolor={theme.palette.grey[200]}>
                <PremissasText />
                <GradientButton label="#Dúvidas" onClick={() => setDimensionadoDrawerStatus(true)} />
              </Box>
            </Box>
          )}
        </>
      </Layout>
    </>
  );
}


export { LayoutProjetoDimensionado }